<template>
  <div class="tree-node">
    <!-- RIGA -->
    <div
      class="tree-row"
      :class="{
        selected: node.id === selectedId,
        highlighted: highlightIds.includes(node.id)
      }"
      @click="selectNode"
    >
      <span
        class="toggle"
        @click.stop="toggle"
      >
        <span v-if="hasChildren">
          {{ open ? "▼" : "▶" }}
        </span>
        <span v-else>
          &nbsp;
        </span>
      </span>
      <span class="label">
         {{ node.id }} - {{ node.nome }}
      </span>
    </div>
    <!-- FIGLI -->
    <div
      v-if="hasChildren && open"
      class="children"
    >
      <PICTreeItem
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :highlight-ids="highlightIds"
        :selected-id="selectedId"
        @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>

export default {

  name: "PICTreeItem",
  props: {
    node: {
      type: Object,
      required: true
    },
     // nodi trovati dalla ricerca
    highlightIds: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: null
    }
  },

  data() {

    return {
      open: !!this.node.expanded
    };
  },

  computed: {

    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    }
  },

  watch: {
  highlightIds: {
    immediate: true,
    handler() {
      this.open = this.containsHighlight(this.node);
    }
  }
},

 mounted() {

  // apre automaticamente i rami che contengono risultati
  if (this.containsHighlight(this.node)) {
    this.open = true;
  }

  // scroll solo sul primo risultato trovato
  if (
    this.highlightIds.length &&
    this.node.id === this.highlightIds[0]
  ) {
    this.$nextTick(() => {
      this.$el.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
  }
},

  methods: {

    toggle() {
      if (this.hasChildren)
        this.open = !this.open;
    },

    selectNode() {
      this.$emit("select", this.node);
    },

     /* verifica ricorsivamente se questo ramo contiene almeno un risultato della ricerca */
    containsHighlight(node) {
      if (!this.highlightIds.length) {
        return false;
      }
      if (this.highlightIds.includes(node.id)) {
        return true;
      }
      if (!node.children) {
        return false;
      }
      return node.children.some(child =>
        this.containsHighlight(child)
      );
    }
  }
};

</script>

<style scoped>

.tree-row {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
}

.tree-row:hover {
  background: rgb(176, 210, 245);
}

.highlighted {
  background: #cfe2ff;   /* primary light */
  color: #084298;        /* primary dark */
  font-weight: 600;
  border-left: 3px solid #0d6efd;
}

.toggle {
  width: 18px;
  text-align: center;
  margin-right: 5px;
  color: #666;
}

.label {
  flex: 1;
}

.children {
  margin-left: 18px;
  border-left: 1px dashed #ddd;
  padding-left: 6px;
}

/* Nodo selezionato */
.selected {
  background: #f4f6f9;
  color: #373F66;
  font-weight: 600;
  border: 2px solid #373F66;
}

</style>